import { Injectable } from '@angular/core';
import { SwUpdate } from '@angular/service-worker';

@Injectable({ providedIn: 'root' })
export class AppUpdateService {

  private updateTriggered = false;

  constructor(private swUpdate: SwUpdate) {
    if (this.swUpdate.isEnabled) {
      this.swUpdate.versionUpdates.subscribe(event => {
        console.log('[AppUpdate] SW version event:', event.type);
        if (event.type === 'VERSION_READY') {
          console.log('[AppUpdate] New version ready — current:', event.currentVersion.hash, '→ latest:', event.latestVersion.hash);
        }
      });
    }
  }

  /** Check for a new SW version, activate it, and reload the page. */
  async checkForUpdateAndReload(): Promise<void> {
    if (!this.swUpdate.isEnabled || this.updateTriggered) {
      return;
    }

    try {
      const updateFound = await this.swUpdate.checkForUpdate();
      console.log('[AppUpdate] checkForUpdate result:', updateFound);

      if (updateFound) {
        this.updateTriggered = true;
        const activated = await this.swUpdate.activateUpdate();
        console.log('[AppUpdate] activateUpdate result:', activated);
        if (activated) {
          document.location.reload();
        }
      }
    } catch (err) {
      console.error('[AppUpdate] Update check failed:', err);
    }
  }

  /** Lightweight check — does not activate or reload. Use for periodic polling. */
  async checkForUpdate(): Promise<void> {
    if (!this.swUpdate.isEnabled) {
      return;
    }
    try {
      await this.swUpdate.checkForUpdate();
    } catch (err) {
      console.error('[AppUpdate] Periodic check failed:', err);
    }
  }
}
